import { observable, computed } from 'mobx';
import { AppStore } from '../app/app.store';

export class LivingRoomStore {
    appStore;

    @observable page = [];
    @observable currentRoomNum = 1;

    constructor() {
        this.appStore = AppStore.getInstance();
    }

    @computed get numRooms() {
        return this.appStore.stairwells + 1;
    }
}
